/**
 * Desktop
 */
// update desktop map position
export function updateDesktopMap(
  ref,
  {
    stationId,
    categoryId,
    desktopSizePosition: { imageX, imageY, drawingX, drawingY, mapW } = {},
  }
) {
  if (!mapW) return;

  const imageMap = ref.querySelector('#pattern0 > use');
  const drawing = ref.querySelector('#map-navigation');

  const dX = getDesktopMapDeltaX({ stationId, categoryId });
  const dY = 0;

  imageMap.setAttribute(
    'transform',
    `translate(${imageX + dX}, ${imageY + dY})`
  );
  drawing.setAttribute(
    'transform',
    `translate(${drawingX + dX}, ${drawingY + dY})`
  );
}

// X moved to centered the category / station horizontally
function getDesktopMapDeltaX({ categoryId, stationId }) {
  const DEFAULT_DX = 0;
  const STATION_DX = {
    // breeding
    'anthony-lagoon': 140,
    'eva-downs': 140,
    'brunette-downs': 140,
    'avon-downs': 0,
    'austral-downs': 0,
    headingly: 0,
    wondoola: -60,
    canobie: -60,
    dalgonally: -60,
    carrum: -60,
    // grazing
    'south-galway': -250,
    glentana: -420,
    wylarah: -420,
    // nourishing
    'goonoo-feedlot': -550,
    'aronui-feedlot': -550,
    // progressing
    'processing-plant': -650,
  };
  const CATEGORY_DX = {
    grazing: -250,
    breeding: 0,
    nourishing: -550,
    progressing: -650,
  };

  return STATION_DX[stationId] ?? CATEGORY_DX[categoryId] ?? DEFAULT_DX;
}

export function getStartingSizePosition(width, height) {
  const VIEWBOX_WIDTH = {
    sm: 1440,
    lg: 3000,
  };

  const VIEWBOX_HEIGHT = {
    sm: 840,
    lg: 2000,
  };

  const IMAGE_POSITION = {
    x: -1931,
    y: -719,
  };

  const isSmallWidth = (w) => w <= VIEWBOX_WIDTH.sm;
  const isMidWidth = (w) => w > VIEWBOX_WIDTH.sm && w < VIEWBOX_WIDTH.lg;
  const isBigWidth = (w) => w >= VIEWBOX_WIDTH.lg;

  const isSmallHeight = (h) => h <= VIEWBOX_HEIGHT.sm;
  const isMidHeight = (h) => h > VIEWBOX_HEIGHT.sm && h < VIEWBOX_HEIGHT.lg;
  const isBigHeight = (h) => h >= VIEWBOX_HEIGHT.lg;

  let mapW,
    drawingX,
    imageX = 0; // horizontal
  let mapH,
    drawingY,
    imageY = 0; // vertical

  if (isSmallWidth(width)) {
    drawingX = 0;
    imageX = IMAGE_POSITION.x;
    mapW = VIEWBOX_WIDTH.sm;
  } else if (isMidWidth(width)) {
    const dx = width - VIEWBOX_WIDTH.sm;
    drawingX = 0 + dx / 2;
    imageX = IMAGE_POSITION.x + dx / 2;
    mapW = width;
  } else if (isBigWidth(width)) {
    const dx = VIEWBOX_WIDTH.lg - VIEWBOX_WIDTH.sm;
    drawingX = 0 + dx / 2;
    imageX = IMAGE_POSITION.x + dx / 2;
    mapW = VIEWBOX_WIDTH.lg;
  }

  if (isSmallHeight(height)) {
    const dy = VIEWBOX_HEIGHT.sm - height;
    drawingY = dy / 1.8;
    imageY = IMAGE_POSITION.y + dy / 1.8;
    mapH = VIEWBOX_HEIGHT.sm * 1.5;
    mapW = VIEWBOX_WIDTH.sm * 1.5;
  } else if (isMidHeight(height)) {
    const dy = height - VIEWBOX_HEIGHT.sm;
    drawingY = 0 + dy / 2;
    imageY = IMAGE_POSITION.y + dy / 2;
    mapH = height;
  } else if (isBigHeight(height)) {
    const dy = VIEWBOX_HEIGHT.lg - VIEWBOX_HEIGHT.sm;
    drawingY = 0 + dy / 2;
    imageY = IMAGE_POSITION.y + dy / 2;
    mapH = VIEWBOX_HEIGHT.lg;
  }

  return {
    mapW,
    mapH,
    drawingX,
    drawingY,
    imageX,
    imageY,
  };
}

export function resizeDesktopMap(
  ref,
  { drawingX, drawingY, imageX, imageY, mapW, mapH }
) {
  if (!mapW) return;

  // update svg viewbox
  let viewBox = ref.viewBox.baseVal;
  viewBox.width = mapW;
  viewBox.height = mapH;

  // update map navigation (layer svg)
  const drawing = ref.querySelector('#map-navigation');
  drawing.setAttribute('transform', `translate(${drawingX}, ${drawingY})`);

  // update image position
  const imageMap = ref.querySelector('#pattern0 > use');
  imageMap.setAttribute('transform', `translate(${imageX}, ${imageY})`);
}
